export const globals = {
  QQT_ROOT: '/qqt/api',
  SAMIKSHA_ROOT: '/rest',
  OPS_API_ROOT: '/ops-rest-api',
  sessionCookie: 'bbqn_ops_session',
  GET_DUEAUDIT: '/audit/dueList', //'/template/audit/dueList',
  GET_POSTAUDIT: '/audit/postList', //'/template/audit/postList',
  GET_QUESTIONLIST: '/template/audit/listQuestions/',
  GET_FEEDQUESTIONLIST: '/template/listQuestions/',
  GET_OUTLETINFO: '/rest/outlet/outletInfo/',
  INSIGHTS_ROOT: 'https://erpapi.bnhl.in/insightsapi/service1.svc',
  rTypeOption: [
    { value: 'RG', label: 'Region' },
    { value: 'SR', label: 'Sub Region' },
    { value: 'CL', label: 'Cluster' },
    { value: 'CT', label: 'City' },
    { value: 'ST', label: 'Store' }
  ],
  reviewTrendRTypeOptions: [
    {Id: 1, value: 'RG', label: 'Region'},
    {Id: 1, value: 'SR', label: 'Sub Region'},
    {Id: 2, value: 'CT', label: 'City'},
    {Id: 3, value: 'ST', label: 'Store'},
    {Id: 4, value: 'TR', label: 'Tier'},
    {Id: 5, value: 'BL', label: 'Building'},
    {Id: 6, value: 'CL', label: 'Cluster'},
    {Id: 7, value: 'ML', label: 'Model'},
    {Id: 8, value: 'TA', label: 'Trade Area'},
    {Id: 10, value: 'LQ', label: 'Liquor'},
    {Id: 9, value: 'VT', label: 'Vintage'},
    {Id: 10, value: 'DT', label: 'Department'},
    {Id: 10, value: 'GR', label: 'Grade'},
    {Id: 10, value: 'DG', label: 'Designation'},
    {Id: 10, value: 'SC', label: 'Staff Category'},
    {Id: 10, value: 'AG', label: 'Ageing'},
    {Id: 10, value: 'GA', label: 'Grade Aging'}
  ],
  POST_SUBMITTEMPLATE: '/feedback/audit/create/',
  POST_SUBMITFEEDTEMPLATE: '/feedback/create',
  POST_SAVETEMPLATE: '/feedback/audit/saveDraft/',
  quarterOptions: [
    { value: '1', label: 'Quarter1' },
    { value: '2', label: 'Quarter2' },
    { value: '3', label: 'Quarter3' },
    { value: '4', label: 'Quarter4' }
  ],
  SSGTypeOption: [
    { label: 'All', value: '' },
    { label: 'SSG MTD', value: 'M' },
    { label: 'SSG YTD', value: 'Y' }
  ],
  sTypeOption: [
    { value: 'D', label: 'Daily' },
    { value: 'W', label: 'Weekly' },
    { value: 'M', label: 'Monthly' }
  ],
  PAGINATION_PAGE_OPTIONS : [
    {value: 15, label: '15'},
    {value: 25, label: '25'},
    {value: 50, label: '50'},
    {value: 100, label: '100'},
  ]
};
